import { AuthenticationResult } from "@azure/msal-browser";
import { ReduxHelper } from "helpers";
import {
  IGetAllWarehousesRequest,
  IGetByIdRequest,
  IUser,
  IWarehouse,
  IAuthenticate,
  IAuthenticateRequest,
  IChangePasswordRequest,
  IThirdPartyAuthenticationRequest,
} from "model";

export const prefix = "IDENTITY";

export const authenticate = ReduxHelper.generateActions<
  IAuthenticateRequest,
  IAuthenticate
>(prefix, "AUTHENTICATE");

export const pingAuthenticate = ReduxHelper.generateActions<
  IThirdPartyAuthenticationRequest,
  IAuthenticate
>(prefix, "PING");

export const microsoftAzureAuthenticate =
  ReduxHelper.generateLocalAction<AuthenticationResult>(
    prefix,
    "MICROSOFT_AZURE_AUTHENTICATE"
  );

export const changePassword = ReduxHelper.generateActions<
  IChangePasswordRequest,
  any
>(prefix, "CHANGE_PASSWORD");

export const getAllWarehouses = ReduxHelper.generateActions<
  IGetAllWarehousesRequest,
  IWarehouse[]
>(prefix, "GET_ALL_WHOUSES");

export const setCurrentWarehouse = ReduxHelper.generateLocalAction<IWarehouse>(
  prefix,
  "SET_CURRENT_WHOUSES"
);
export const logout = ReduxHelper.generateLocalAction(prefix, "LOG_OUT");

export const setDeviceId = ReduxHelper.generateLocalAction<string>(
  prefix,
  "SET_DEVICE_ID"
);

export const getCurrentUser = ReduxHelper.generateActions<
  IGetByIdRequest,
  IUser
>(prefix, "GET_CURRENT_USER");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
